export function isPalavras(tenantSlug?: string): boolean {
  // Identidade institucional global; o contexto segue isolando dados, não o tema.
  void tenantSlug
  return true
}

export function applyPublisherBrand(tenantSlug: string) {
  if (isPalavras(tenantSlug)) {
    document.documentElement.dataset.publisher = 'palavras'
    document.title = 'Palavras Educação · Leitor'
  } else {
    delete document.documentElement.dataset.publisher
    document.title = 'Lúmina — Leitor'
  }
}
